__turbopack_context__.v({
  "Root": "S7lk7a_Root",
  "Root--Bg": "S7lk7a_Root--Bg",
  "Root--Svg": "S7lk7a_Root--Svg",
  "skeleton-loading": "S7lk7a_skeleton-loading",
});
